// mds-dojo — dijit/DropDownMenu — FAITHFUL port of references/dijit/DropDownMenu.js.
// A menu without context-menu features (i.e. a drop down menu). declare from the
// faithful runtime; template ?raw. Unused `dojo/keys` import dropped.
import declare from '../dojo/_base/declare-runtime'; // declare
import template from './templates/Menu.html?raw';
import _MenuBase from './_MenuBase';

export default declare('dijit.DropDownMenu', _MenuBase, {
  // summary:
  //		A menu, without features for context menu (Meaning, drop down menu)

  templateString: template,

  baseClass: 'dijitMenu',

  // Arrow key navigation
  _onUpArrow: function () {
    this.focusPrev();
  },
  _onDownArrow: function () {
    this.focusNext();
  },
  _onRightArrow: function (/*Event*/ evt: any) {
    this._moveToPopup(evt);
    evt.stopPropagation();
    evt.preventDefault();
  },
  _onLeftArrow: function (/*Event*/ evt: any) {
    if (this.parentMenu) {
      if (this.parentMenu._isMenuBar) {
        this.parentMenu.focusPrev();
      } else {
        this.onCancel(false);
      }
    } else {
      evt.stopPropagation();
      evt.preventDefault();
    }
  },
});
